module.exports = __webpack_public_path__ + "static/Chicory0-4119c84a393be940466f7dbaad8b0623.webp";